import { View } from 'react-native';
import { Image } from 'shared/components/image';
import { Text } from 'shared/components/text';
import { breederReviews } from 'shared/library/reviews';

type BreederSocialProofProps = {
  prefix: string;
  count: string;
  suffix: string;
  className?: string;
};

const BreederSocialProof = ({ prefix, count, suffix, className }: BreederSocialProofProps) => {
  const socialProofReviews = breederReviews.slice(0, 5);

  return (
    <View className={className ?? 'mt-4 flex-row items-center gap-3'}>
      <View className={'flex-row'}>
        {socialProofReviews.map((review, index) => (
          <View key={review.identifier} className={index === 0 ? '' : '-ml-4'}>
            <Image
              src={review.image ?? ''}
              alt={review.name}
              containerClassName={'relative size-9 overflow-hidden rounded-full md:size-10'}
              imageClassName={'rounded-full border-2 border-white object-cover'}
              sizeType={'avatar'}
            />
          </View>
        ))}
      </View>

      <Text className={'text-brand-brown-dark/65 flex-1 text-xs md:text-sm'}>
        {prefix}{' '}
        <Text className={'text-brand-brown-dark text-xs font-bold md:text-sm'}>{count}</Text>{' '}
        {suffix}.
      </Text>
    </View>
  );
};

export { BreederSocialProof };
export type { BreederSocialProofProps };
